import Component from '../../common/Component';
import classList from '../../common/utils/classList';
import Link from '../../common/components/Link';
import humanTime from '../../common/helpers/humanTime';
import Icon from '../../common/components/Icon';
export default class HeaderListItem extends Component {
  view(vnode) {
    const {
      avatar,
      icon: iconName,
      content,
      excerpt,
      datetime,
      href,
      className,
      onclick,
      actions,
      ...attrs
    } = vnode.attrs;
    const Tag = href ? Link : 'button';
    return m(Tag, Object.assign({
      className: classList('HeaderListItem', className, {
        'Button--ua-reset': Tag === 'button'
      }),
      href: href,
      external: href?.includes('://'),
      onclick: onclick
    }, attrs), avatar, m(Icon, {
      name: iconName,
      className: "HeaderListItem-icon"
    }), m("span", {
      className: "HeaderListItem-title"
    }, m("span", {
      className: "HeaderListItem-content"
    }, content), m("span", {
      className: "HeaderListItem-title-spring"
    }), m("span", {
      className: "HeaderListItem-time"
    }, datetime && humanTime(datetime))), m("div", {
      className: "HeaderListItem-actions"
    }, actions), m("div", {
      className: "HeaderListItem-excerpt"
    }, excerpt));
  }
}
flarum.reg.add('core', 'forum/components/HeaderListItem', HeaderListItem);